// extracted by mini-css-extract-plugin
export default {"emptyState":"UserGuide_emptyState__rcVxZ","sidePanel":"UserGuide_sidePanel__s0m0b"};